/** Canonical dietary label display map shared by web and mobile. */
export const DIETARY_LABEL_DISPLAY = {
    vegan: "Vegan",
    vegetarian: "Veg",
    gluten_free: "GF",
    dairy_free: "Dairy-free",
    nut_free: "Nut-free",
    halal: "Halal",
    kosher: "Kosher",
    keto: "Keto",
    low_carb: "Low-carb",
};
/** Maps raw dietary label keys to display strings, falling back to the
 *  original label, and slicing to max (default 3) items. */
export function formatDietaryLabels(labels, max = 3) {
    return labels
        .map((label) => DIETARY_LABEL_DISPLAY[label] ?? label)
        .filter((label) => label.length > 0)
        .slice(0, max);
}
//# sourceMappingURL=dietary.js.map